import { useEffect } from "react";

export default function ChaportWidget() {
  useEffect(() => {
    if (window.chaport) return;

    (function(w, d, v3) {
      w.chaportConfig = { appId: "690f31ddd0a09ec2a22e0917" };
      if (w.chaport) return;
      v3 = w.chaport = {};
      v3._q = [];
      v3._l = {};
      v3.q = function() { v3._q.push(arguments); };
      v3.on = function(e, fn) {
        if (!v3._l[e]) v3._l[e] = [];
        v3._l[e].push(fn);
      };
      const s = d.createElement("script");
      s.type = "text/javascript";
      s.async = true;
      s.src = "https://app.chaport.com/javascripts/insert.js";
      const ss = d.getElementsByTagName("script")[0];
      ss.parentNode.insertBefore(s, ss);
    })(window, document);
  }, []);

  return null; // 这个组件不渲染任何可见内容
}
